import React from 'react';

class RenderIf extends React.Component {
	static propTypes = {
		exists: React.PropTypes.any,
		notExists: React.PropTypes.any,
		isTrue: React.PropTypes.bool,
		isFalse: React.PropTypes.bool,
		isEmpty: React.PropTypes.array,
		isNotEmpty: React.PropTypes.array,
		children: React.PropTypes.any,
	};

	shouldRender() {
		if (this.props.hasOwnProperty('exists') && Boolean(this.props.exists)) {
			return true;
		}

		if (this.props.hasOwnProperty('notExists') && !Boolean(this.props.notExists)) {
			return true;
		}

		if (this.props.hasOwnProperty('isTrue') && this.props.isTrue === true) {
			return true;
		}

		if (this.props.hasOwnProperty('isFalse') && this.props.isFalse === false) {
			return true;
		}

		if (this.props.hasOwnProperty('isEmpty') && Array.isArray(this.props.isEmpty) && this.props.isEmpty.length === 0) {
			return true;
		}

		if (this.props.hasOwnProperty('isNotEmpty') && Array.isArray(this.props.isNotEmpty) && this.props.isNotEmpty.length !== 0) {
			return true;
		}

		return false;
	}

	render() {
		if (!this.shouldRender()) {
			return null;
		}

		if (this.props.children.length > 1) {
			return <div>{this.props.children}</div>;
		}

		return this.props.children;
	}
}

export default RenderIf;



// WEBPACK FOOTER //
// ./src/components/RenderIf.js